// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
// Models
import { MruApp } from "../service/mru/MruApp";
import { MruExtension } from "../service/mru/MruExtension";
/**
 * Get the PlanType for the MRU app. Returns null if there is no valid mapping.
 * @param mruApp The MRU app
 */ export function getPlanTypeForMruApp(mruApp) {
    switch(mruApp){
        case MruApp.Project:
            return PlanType.Premium;
        case MruApp.ToDo:
            return PlanType.ToDo;
        case MruApp.Planner:
            return PlanType.Unified;
        default:
            return null;
    }
}
/**
 * Filter that returns true if the MRU item has an app type Portfolio
 * @param mruItem The Mru item
 * @returns True if it's a portfolio/roadmap else false
 */ export function isMruItemAPortfolio(mruItem) {
    return mruItem.app === MruApp.Portfolio;
}
/**
 * Filter that returns true if the MRU item is a Planner task (task-level favorite).
 * Retained to filter out orphan task MRU items left in cloud storage so they don't render in the leftnav.
 * @param mruItem The MRU item
 * @returns True if it's a planner task, else false.
 */ export function isMruItemATask(mruItem) {
    return mruItem.app === MruApp.Planner && mruItem.extension === MruExtension.PlannerTask;
}
/** Filtering function to segregate plan items from MRU items.
 * @param mruItem The MRU item
 * @returns True if it's a plan, else false.
 */ export function isMruItemAPlan(mruItem) {
    if (isMruItemATask(mruItem)) return false;
    return getPlanTypeForMruApp(mruItem.app) !== null;
}
